import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import ContainerPage from './ContainerComponents/ContainerPage';
import ContainerListPage from './ContainerComponents/ContainerListPage';

export interface IUrlParameters {
  containerId: string | undefined;
  storeId: string | undefined;
}

export const ContainerView = ({
  match,
}: RouteComponentProps<IUrlParameters>) => {
  if (!match.params.containerId) {
    return <ContainerListPage storeId={match.params.storeId} />;
  }

  return <ContainerPage containerId={match.params.containerId} />;
};
